import { createEntityFilesBlock } from "../entity/createEntityFilesBlock.jsx";
import { canEnterHoursUnlimited, getRoleId, ROLE_MITARBEITER } from "../../constants/roles.js";
import { sanitizeFileUrl } from "../../utils/filePreview.js";

function pickSafeUrl(...candidates) {
  for (const candidate of candidates) {
    const safe = sanitizeFileUrl(candidate || "");
    if (safe) return safe;
  }
  return "";
}

const INVENTAR_TYPEN = ["Plan", "Offerte", "Rechnung", "Bestellung", "Protokoll", "Rapport", "E-Mail", "Foto", "Skizze", "Sonstiges"];

const InventarEntityFilesBlock = createEntityFilesBlock({
  title: "📄 Dokumente",
  compact: true,
  fileActionMode: "minimal",
  fileActionCompact: true,
  defaultTypes: INVENTAR_TYPEN,
  getApiBase: () => null,
  getApiPaths: (artikelId) => ({
    list: `/inventar/${artikelId}/dokumente`,
    create: `/inventar/${artikelId}/dokument`,
    remove: (id) => `/inventar/${artikelId}/dokumente/${id}`,
  }),
  parseItems: (data) => {
    const payload = data?.data || data || {};
    const rows = Array.isArray(payload) ? payload : payload?.items || payload?.dateien || [];
    return rows;
  },
  resolveFileUrl: (row) =>
    pickSafeUrl(row?.secure_preview_url, row?.secure_download_url, row?.secure_url),
  canUpload: (_entityId, user) => canEnterHoursUnlimited(user) || getRoleId(user) === ROLE_MITARBEITER,
  previewModule: "inventory_files",
});

export default function InventarBlockFotos({ artikelId }) {
  return <InventarEntityFilesBlock entityId={artikelId} />;
}
